import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import datePicker from '../../component/dccore-form/datePicker.vue'
import moment from 'moment'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import Multiselect from '../../component/dccore-form/NewMultiSelect.vue'
import toastr from '../toastr'

require('bootstrap')

if ($('#kitchen_report_summary').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#kitchen_report_summary',
    components: {
      datePicker,
      Singleselect,
      Multiselect
    },
    mixins: [mixins],
    data: {
      dateFrom: moment().locale('pl').format('YYYY-MM-DD'),
      dateTo: moment().locale('pl').format('YYYY-MM-DD'),
      brand: null,
      team: null,
      dateType: null,
      brands: [],
      teams: [],
      loadingBrands: false,
      loadingTeams: false,
      buttonsDisabled: false,
      form: {
        options: {
          errors: {},
        }
      },
    },
    watch: {
      dateFrom: function() {
        this.validateDate()
      },
      dateTo: function() {
        this.validateDate()
      }
    },
    mounted: function () {
      this.getBrands()
      this.getTeams()
    },
    created: function () {
      this.DATE_TYPES = [
        {
          id: 'delivery_date',
          name: 'Data dostawy'
        },
        {
          id: 'production_date',
          name: 'Data produkcji'
        }
      ]
    },
    methods: {
      generatePdf() {
        if (
          (this.brand === null || this.brand.length <= 0) ||
          this.dateType === null ||
          (this.team === null || this.team.length <= 0)
        ) {
          toastr.error(Translator.trans('kitchen_summary_report.missing_required_params'))
        } else {
          window.open(Routing.generate('kitchen_summary_report_generate', {
            dateType: this.dateType,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
            brandIds: this.brand,
            reportType: 'kitchen',
            teamIds: this.team
          }), '_blank')
        }
      },
      validateDate() {
        const toDate = new Date(this.dateTo)
        const fromDate = new Date(this.dateFrom)
        if (toDate < fromDate) {
          this.buttonsDisabled = true
          this.form.options.errors = { dateTo: Translator.trans('form.errors.date_to_must_be_equal_greater') }
        } else {
          this.buttonsDisabled = false
          this.form.options.errors = {}
        }
      },
      getBrands() {
        let url = Routing.generate('api_get_brands', { context: 'dropdown' })
        this.loadingBrands = true
        this.$http.get(url).then(response => {
          this.brands = response.data
          this.loadingBrands = false
        }, response => {
          this.handleAjaxError(response)
          this.loadingBrands = false
        })
      },
      getTeams() {
        let url = Routing.generate('api_get_active_production_teams', { context: 'dropdown' })
        this.loadingTeams = true
        this.$http.get(url).then(response => {
          this.teams = [
            {
              text: 'Brak',
              id: -1,
              name: 'Brak',
              isActive: true
            },
            ...response.data
          ]
          this.loadingTeams = false
        }, response => {
          this.handleAjaxError(response)
          this.loadingTeams = false
        })
      }
    }
  })
}
